import forgotPasswordModule from '../scripts/forgotPassword/forgotPassword.module.js';
import appDependency from '../scripts/appDependency.js';
appDependency.addItem(forgotPasswordModule);